import React from 'react'
import LtsDropdownUnidade from '../../../components/lottus/lts-dropdown-unidade'
import _ from 'lodash'
import { getMessage } from '../../../utils'
import { Card } from 'primereact/card'
import LtsLookupContaCorrente from '../../../components/lottus/lts-lookup-conta-corrente'
import LtsCalendar from '../../../components/lottus/lts-calendar'
import LtsLookupPessoa from '../../../components/lottus/lts-lookup-pessoa'
import { enums, icons } from '../../../constants'
import LtsInputText from '../../../components/lottus/lts-input-text'
import LtsCurrency from '../../../components/lottus/lts-currency'
import { Button } from 'primereact/button'
import { Divider } from 'primereact/divider'
import RemessaPagamentoItem from './remessa-pagamento-item'
import LtsLookupTaxa from '../../../components/lottus/lts-lookup-taxa'

export const RemessaPagamentoForm = (props) => {
  const record = props.record
  const item = props.item
  const messages = props.messages
  const setField = props.setField
  const setItem = props.setItem

  function checkIncluirDisabled(item) {
    return (
      !item.beneficiario ||
      !item.taxa ||
      !item.dataPagamento ||
      !item.codigoBarras ||
      !item.valor ||
      !item.dataVencimento
    )
  }

  return (
    <div className="p-grid p-fluid">
      <div className="p-col-12">
        <Card>
          <div className="p-grid form-group">
            <div className="p-col-12 p-sm-12 p-md-10 p-lg-8 p-xl-6">
              <LtsDropdownUnidade
                name={'unidade'}
                label={getMessage(messages, 'remessapagamento.label.unidade')}
                value={record.unidade}
                onChange={(e) => setField('unidade', e)}
                disabled={props.disableUnit}
              />
            </div>
          </div>
          <div className="p-grid form-group">
            <div className="p-col-12 p-sm-6 p-md-4 p-lg-3 p-xl-3">
              <LtsLookupContaCorrente
                label={getMessage(messages, 'remessapagamento.label.contacorrente')}
                value={_.get(record, 'contaCorrente.value', '')}
                oidRecord={_.get(record, 'contaCorrente.id', '')}
                history={props.history}
                onChange={(e) => setField('contaCorrente', { id: e.oid, value: e.descricao })}
              />
            </div>
          </div>
          <div className="p-grid form-group">
            <div className="p-col-12">
              <LtsCalendar
                className={'width-15-rem'}
                value={record.dataPagamento}
                name={'dataPagamento'}
                label={getMessage(messages, 'remessapagamento.label.dataPagamento')}
                onChange={(e) => {
                  setField('dataPagamento', e)
                  if (!item.dataPagamento) {
                    setItem('dataPagamento', e)
                  }
                }}
              />
            </div>
          </div>
          <div className="p-grid form-group">
            <div className="p-col-12 p-sm-6 p-md-4 p-lg-3 p-xl-3">
              <LtsLookupTaxa
                value={_.get(record, 'taxa.value', null)}
                editHidden={true}
                field={'taxa'}
                multiple={false}
                onChange={(e) => {
                  const value = {
                    id: _.get(e, 'oid', null),
                    value: _.get(e, 'grupoFinanceiro_descricao', null),
                  }
                  setField('taxa', value)
                  if (!item.taxa) {
                    setItem('taxa', value)
                  }
                }}
                label={getMessage(messages, 'remessapagamento.label.taxa')}
                header={getMessage(messages, 'remessapagamento.label.taxa')}
                filtroTipoTaxa={enums.TipoTaxa.SAIDA}
                idUnidade={_.get(record, 'unidade.id', null)}
              />
            </div>
          </div>
          <Divider />
          <div className="p-grid form-group">
            <div className="p-col-12 p-sm-6 p-md-4 p-lg-3 p-xl-3">
              <LtsLookupPessoa
                header={getMessage(messages, 'remessapagamento.label.beneficiario')}
                name={'beneficiario'}
                field={'beneficiario'}
                label={getMessage(messages, 'remessapagamento.label.beneficiario')}
                value={{
                  id: _.get(item, 'beneficiario.id', null),
                  value: _.get(item, 'beneficiario.value', null),
                }}
                oidRecord={_.get(record, 'beneficiario.id', '')}
                history={props.history}
                onChange={(e) => setItem('beneficiario', { id: e.oid, value: e.nome })}
                statePessoaFisica={props.statePessoaFisica}
                statePessoaJuridica={props.statePessoaJuridica}
                tipoPessoa={enums.TipoPessoa.AMBAS}
                showAddButton={false}
              />
            </div>
          </div>
          <div className="p-grid form-group">
            <div className="p-col-12 p-sm-6 p-md-4 p-lg-3 p-xl-3">
              <LtsLookupTaxa
                value={_.get(item, 'taxa.value', null)}
                editHidden={true}
                field={'taxa'}
                multiple={false}
                onChange={(e) => {
                  const value = {
                    id: _.get(e, 'oid', null),
                    value: _.get(e, 'grupoFinanceiro_descricao', null),
                  }
                  setItem('taxa', value)
                }}
                label={getMessage(messages, 'remessapagamento.label.taxa')}
                header={getMessage(messages, 'remessapagamento.label.taxa')}
                filtroTipoTaxa={enums.TipoTaxa.SAIDA}
                idUnidade={_.get(record, 'unidade.id', null)}
              />
            </div>
          </div>
          <div className="p-grid form-group">
            <div className="p-col-12">
              <LtsCalendar
                className={'width-15-rem'}
                value={item.dataPagamento}
                name={'dataPagamento'}
                label={getMessage(messages, 'remessapagamento.label.dataPagamento')}
                onChange={(e) => setItem('dataPagamento', e)}
              />
            </div>
          </div>

          <div className="p-grid form-group">
            <div className="p-col-12 p-sm-12 p-md-8 p-lg-8 p-xl-6">
              <LtsInputText
                value={item.codigoBarras}
                onChange={(e) => setItem('codigoBarras', e)}
                name="codigoBarras"
                maxLength={65}
                label={getMessage(messages, 'remessapagamento.label.codigoBarras')}
              />
            </div>
          </div>
          <div className="p-grid form-group">
            <div className="p-col-6 p-sm-6 p-md-4 p-lg-3 p-xl-3">
              <LtsCurrency
                value={item.valor}
                name={'valor'}
                label={getMessage(messages, 'remessapagamento.label.valor')}
                onChange={(e) => setItem('valor', e)}
                disabled={item.valorVencimentoByCodigoBarras}
              />
            </div>
          </div>
          <div className="p-grid form-group">
            <div className="p-col-12">
              <LtsCalendar
                className={'width-15-rem'}
                value={item.dataVencimento}
                name={'dataVencimento'}
                label={getMessage(messages, 'remessapagamento.label.dataVencimento')}
                onChange={(e) => setItem('dataVencimento', e)}
                disabled={item.valorVencimentoByCodigoBarras}
              />
            </div>
          </div>
          <div className="p-grid form-group">
            <div className="p-col-6 p-sm-4 p-md-3 p-lg-3 p-xl-3">
              <Button
                onClick={(e) => props.addItem(item)}
                label={getMessage(props.messages, 'remessapagamento.label.incluirPagamento')}
                icon={icons.PLUS_ICON}
                className="p-button-success"
                disabled={checkIncluirDisabled(item)}
              />{' '}
            </div>
          </div>
          <Divider />
          <RemessaPagamentoItem
            values={props.itens}
            messages={props.messages}
            onClickRemoveItem={props.onClickRemoveItem}
          ></RemessaPagamentoItem>
        </Card>
      </div>
    </div>
  )
}
